import * as React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

import variables from 'assets/styles/scss/shared/_variables.module.scss'
import { isMobileView } from 'lib/GlobalConstants'

const HtmlStyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    id="tooltip"
    enterTouchDelay={0}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: variables.white,
    maxWidth: isMobileView ? 'fit-content' : '19.5rem',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '1rem',
    fontWeight: 'unset',
    borderRadius: '0.25rem',
    padding: '1rem',
    boxShadow: `0px 2px 1px -1px ${variables['grey-33']}, 0px 1px 1px ${variables['grey-24']}, 
    0px 1px 3px ${variables['grey-21']}`,
  },
}))

export default HtmlStyledTooltip
